import React, { useState, useEffect } from "react";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import PhoneContact from "../Tools/PhoneContact.jsx";
import PlayStore from "../Tools/PlayStore.jsx";
import PhoneIcon from "@mui/icons-material/Phone";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import GppGoodIcon from "@mui/icons-material/GppGood";
import ShieldIcon from "@mui/icons-material/Shield";
import EventIcon from "@mui/icons-material/Event";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import AppDownloadBanner from "../Tools/AppDownloadBanner.jsx";
import DialogBox from "../Tools/DialogBox";
import basic_car_wash_image from "../images/basic_car_wash.jpg";
import premium_car_wash_image from "../images/premium_car_wash.jpeg";
import premium_plus_car_wash_image from "../images/premium_plus_car_wash.jpg";
import luxury_car_wash_image from "../images/luxury_car_wash.jpeg";
import luxury_plus_car_wash_image from "../images/luxury_plus_car_wash.png";
import premium_bike_wash_image from "../images/premium_bike_wash.jpeg";
import standard_bike_wash_image from "../images/basic_bike_wash.jpeg";
import car_rubbing_image from "../images/car_rubbing.jpeg";
import car_rubbing_coating_image from "../images/rubbing_wax_coating.jpg";
import water_repellent_image from "../images/water_repellent_treatment.jpg";
import bike_rubbing_and_coating_image from "../images/bike_rubbing_and_coating.png";
import bike_hybrid_ceramic_image from "../images/premium_bike_hybrid_coating.jpg";
import car_premium_ceramic_coat_image from "../images/premium_wash_hybrid_ceramic_coat.jpg";
import car_basic_ceramic_coat_image from "../images/basic_hybrid_ceramic_coat.jpg";
import car_interior_basic_image from "../images/basic_interior_cleaning.jpg";
import car_interior_premium_image from "../images/premium_interior_cleaning.jpg";
import car_interior_premium_plus_image from "../images/car_interior_premium_plus.jpg";
import car_interior_luxury_image from "../images/luxury_interior_cleaning.jpg";
import ppf_ceramic_raigarh_image from "../images/ppf_ceramic_raigarh.png";
import PremiumCarWash from "../Content/PremiumCarWash";
import PremiumPlusCarWash from "../Content/PremiumPlusCarWash";
import BasicCarWash from "../Content/BasicCarWash";
import PremiumBikeWash from "../Content/PremiumBikeWash";
import PremiumBikeWashHybridCoat from "../Content/PremiumBikeWashHybridCoat";
import LuxuryCarWash from "../Content/LuxuryCarWash";
import LuxuryPlusCarWash from "../Content/LuxuryPlusCarWash";
import RubbingAndWaxCoating from "../Content/RubbingAndWaxCoating";
import RubbingCarWash from "../Content/RubbingCarWash";
import WaterRepellentCarGlass from "../Content/WaterRepellentCarGlass";
import BikeRubbingAndCoating from "../Content/BikeRubbingAndCoating";
import StandardBikeWash from "../Content/StandardBikeWash";
import PremiumHybridCeramicCoat from "../Content/PremiumHybridCeramicCoat";
import BasicHybridCeramicCoat from "../Content/BasicHybridCeramicCoat";
import BasicInteriorCleaning from "../Content/BasicInteriorCleaning";
import PremiumInterior from "../Content/PremiumInterior";
import PremiumPlusInterior from "../Content/PremiumPlusInterior";
import LuxuryInterior from "../Content/LuxuryInterior";

const LandingPage1 = () => {
  const [activeTab, setActiveTab] = useState("car");
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleWashButtonClick = (type, vehicle) => {
    localStorage.setItem("washType", type);
    localStorage.setItem("vehicleType", vehicle);
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-indigo-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative z-10">
        <div className={`pt-6 mb-0 transition-all duration-700 ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
          <div className="flex items-center justify-center max-w-5xl mx-auto px-4">
            {/* Center: Category buttons */}
            <div className="flex justify-center items-center gap-3 md:gap-4 flex-wrap">
              <Tooltip title="Car Wash" arrow>
                <IconButton
                  aria-label="Car Wash"
                  onClick={() => setActiveTab("car")}
                  sx={{
                    background: activeTab === "car"
                      ? "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
                      : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                    color: activeTab === "car" ? "#fff" : "#4f46e5",
                    border: "none",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    backdropFilter: "blur(10px)",
                    boxShadow: activeTab === "car" 
                      ? "0 10px 25px -5px rgba(99,102,241,0.5), 0 0 0 1px rgba(255,255,255,0.1)" 
                      : "0 4px 6px -1px rgba(0,0,0,0.1), 0 0 0 1px rgba(79,70,229,0.1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    '&:hover': {
                      transform: 'translateY(-2px) scale(1.05)',
                      boxShadow: activeTab === "car" 
                        ? "0 15px 30px -5px rgba(99,102,241,0.6), 0 0 0 1px rgba(255,255,255,0.2)" 
                        : "0 8px 15px -3px rgba(79,70,229,0.3), 0 0 0 1px rgba(79,70,229,0.2)"
                    }
                  }}
                >
                  <DirectionsCarIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Interior" arrow>
                <IconButton
                  aria-label="Interior"
                  onClick={() => setActiveTab("interior")}
                  sx={{
                    background: activeTab === "interior"
                      ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                      : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                    color: activeTab === "interior" ? "#fff" : "#d97706",
                    border: "none",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    backdropFilter: "blur(10px)",
                    boxShadow: activeTab === "interior" 
                      ? "0 10px 25px -5px rgba(245,158,11,0.5), 0 0 0 1px rgba(255,255,255,0.1)" 
                      : "0 4px 6px -1px rgba(0,0,0,0.1), 0 0 0 1px rgba(217,119,6,0.1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    '&:hover': {
                      transform: 'translateY(-2px) scale(1.05)',
                      boxShadow: activeTab === "interior" 
                        ? "0 15px 30px -5px rgba(245,158,11,0.6), 0 0 0 1px rgba(255,255,255,0.2)" 
                        : "0 8px 15px -3px rgba(217,119,6,0.3), 0 0 0 1px rgba(217,119,6,0.2)"
                    }
                  }}
                >
                  <CleaningServicesIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Bike Wash" arrow>
                <IconButton
                  aria-label="Bike Wash"
                  onClick={() => setActiveTab("bike")}
                  sx={{
                    background: activeTab === "bike"
                      ? "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)"
                      : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                    color: activeTab === "bike" ? "#fff" : "#0891b2",
                    border: "none",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    backdropFilter: "blur(10px)",
                    boxShadow: activeTab === "bike" 
                      ? "0 10px 25px -5px rgba(6,182,212,0.5), 0 0 0 1px rgba(255,255,255,0.1)" 
                      : "0 4px 6px -1px rgba(0,0,0,0.1), 0 0 0 1px rgba(8,145,178,0.1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    '&:hover': {
                      transform: 'translateY(-2px) scale(1.05)',
                      boxShadow: activeTab === "bike" 
                        ? "0 15px 30px -5px rgba(6,182,212,0.6), 0 0 0 1px rgba(255,255,255,0.2)" 
                        : "0 8px 15px -3px rgba(8,145,178,0.3), 0 0 0 1px rgba(8,145,178,0.2)"
                    }
                  }}
                >
                  <TwoWheelerIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Coating" arrow>
                <IconButton
                  aria-label="Coating"
                  onClick={() => setActiveTab("coat")}
                  sx={{
                    background: activeTab === "coat"
                      ? "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)"
                      : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                    color: activeTab === "coat" ? "#fff" : "#16a34a",
                    border: "none",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    backdropFilter: "blur(10px)",
                    boxShadow: activeTab === "coat" 
                      ? "0 10px 25px -5px rgba(34,197,94,0.5), 0 0 0 1px rgba(255,255,255,0.1)" 
                      : "0 4px 6px -1px rgba(0,0,0,0.1), 0 0 0 1px rgba(22,163,74,0.1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    '&:hover': {
                      transform: 'translateY(-2px) scale(1.05)',
                      boxShadow: activeTab === "coat" 
                        ? "0 15px 30px -5px rgba(34,197,94,0.6), 0 0 0 1px rgba(255,255,255,0.2)" 
                        : "0 8px 15px -3px rgba(22,163,74,0.3), 0 0 0 1px rgba(22,163,74,0.2)"
                    }
                  }}
                >
                  <GppGoodIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
              <Tooltip title="PPF" arrow>
                <IconButton
                  aria-label="PPF"
                  onClick={() => setActiveTab("ppf")}
                  sx={{
                    background: activeTab === "ppf"
                      ? "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
                      : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                    color: activeTab === "ppf" ? "#fff" : "#1d4ed8",
                    border: "none",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    backdropFilter: "blur(10px)",
                    boxShadow: activeTab === "ppf"
                      ? "0 10px 25px -5px rgba(37,99,235,0.5), 0 0 0 1px rgba(255,255,255,0.1)"
                      : "0 4px 6px -1px rgba(0,0,0,0.1), 0 0 0 1px rgba(29,78,216,0.1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    '&:hover': {
                      transform: 'translateY(-2px) scale(1.05)',
                      boxShadow: activeTab === "ppf"
                        ? "0 15px 30px -5px rgba(37,99,235,0.6), 0 0 0 1px rgba(255,255,255,0.2)"
                        : "0 8px 15px -3px rgba(29,78,216,0.3), 0 0 0 1px rgba(29,78,216,0.2)"
                    }
                  }}
                >
                  <ShieldIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className="flex flex-col pb-8">
          {activeTab === "car" && (
          <>
            {/* Basic Car Wash */}
            <WashCard
              title="Basic Car Wash"
              img={basic_car_wash_image}
              ulItems={[
                "Exterior High Pressure Wash",
                "Exterior Foam Wash",
                "Exterior Glass Polish",
              ]}
              dialogHeading="Basic Car Wash"
              dialogContent={<BasicCarWash />}
              price="250"
              discount="20% Off"
              discountedPrice="200"
              washType="BASIC"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={0}
            />

            {/* Premium Car Wash */}
            <WashCard
              title="Premium Car Wash"
              img={premium_car_wash_image}
              ulItems={["Pressure Foam Wash", "Dashboard & Interior Polish"]}
              dialogHeading="Premium Car Wash"
              dialogContent={<PremiumCarWash />}
              price="500"
              discount="20% Off"
              discountedPrice="400"
              washType="PREMIUM"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={1}
            />

            {/* Premium Plus Car Wash */}
            <WashCard
              title="Premium Plus Car Wash"
              img={premium_plus_car_wash_image}
              ulItems={[
                "Showroom Quality Premium Polish",
                "Free Air Freshener",
                "Foot Mat",
              ]}
              dialogHeading="Premium Plus Car Wash"
              dialogContent={<PremiumPlusCarWash />}
              price="700"
              discount="29% Off"
              discountedPrice="500"
              washType="PREMIUMPLUS"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={2}
            />

            {/* Luxury Car Wash */}
            <WashCard
              title="Luxury Car Wash"
              img={luxury_car_wash_image}
              ulItems={[
                "Advanced Interior Detailing",
                "Dashboard & Interior Polish",
              ]}
              dialogHeading="Luxury Car Wash"
              dialogContent={<LuxuryCarWash />}
              price="1500"
              discount="50% Off"
              discountedPrice="999"
              washType="LUXURY"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={3}
            />

            {/* Luxury Plus Plan */}
            <WashCard
              title="Luxury Plus Plan"
              img={luxury_plus_car_wash_image}
              ulItems={[
                "Car Roof Cleaning",
                "Foot Mat, Tissue Paper, Air Freshener",
                "Interior Special Foam Wash"
              ]}
              dialogHeading="Luxury Plus Plan"
              dialogContent={<LuxuryPlusCarWash />}
              price="1500"
              discount="20% Off"
              discountedPrice="1200"
              washType="LUXURYPLUS"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={4}
            />

            {/* Premium Wash & Hybrid Ceramic Coat */}
            <WashCard
              title="Premium Wash & Hybrid Ceramic Coat"
              img={car_premium_ceramic_coat_image}
              ulItems={["Hybrid Cermaic Coat", "Premium Wash", "Showroom Quality Premium Polish"]}
              dialogHeading="Premium Wash & Hybrid Ceramic Coat"
              dialogContent={<PremiumHybridCeramicCoat />}
              price="1499"
              discount="33% Off"
              discountedPrice="999"
              washType="PREMIUMHYBRIDCERMARICCOAT"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={5}
            />

            {/* Coat */}
            <WashCard
              title="Ceramic Coat"
              img={car_basic_ceramic_coat_image}
              ulItems={["Hybrid Ceramic Coat", "Basic Car Wash"]}
              dialogHeading="Coat"
              dialogContent={<BasicHybridCeramicCoat />}
              price="10000"
              discount="20% Off"
              discountedPrice="8000"
              washType="BASICHYBRIDCERMARICCOAT"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={6}
            />
          </>
        )}

        {activeTab === "bike" && (
          <>
            {/* Premium Bike Wash */}
            <WashCard
              title="Premium Bike Wash"
              img={premium_bike_wash_image}
              ulItems={["Pressure Foam Wash", "Full Body Shine"]}
              dialogHeading="Premium Bike Wash"
              dialogContent={<PremiumBikeWash />}
              price="199"
              discount="25% Off"
              discountedPrice="149"
              washType="PREMIUM"
              vehicleType="BIKE"
              onBook={handleWashButtonClick}
              index={0}
            />

            
            <WashCard
              title="Standard Bike Wash"
              img={standard_bike_wash_image}
              ulItems={["High Pressure Wash"]}
              dialogHeading="Standard Bike Wash"
              dialogContent={<StandardBikeWash />}
              price="199"
              discount="50% Off"
              discountedPrice="99"
              washType="STANDARD"
              vehicleType="BIKE"
              onBook={handleWashButtonClick}
              index={1}
              disabled={true}
              disabledNote="Available with Car wash only"
            />

            {/* Premium Bike Hybrid Coating */}
            <WashCard
              title="Bike Wax Polish"
              img={bike_hybrid_ceramic_image}
              ulItems={[
                "Hybrid Ceramic Coating",
                "Tyre Polish",
                "Full Body Shine Coat",
              ]}
              dialogHeading="Premium Bike Hybrid Coating"
              dialogContent={<PremiumBikeWashHybridCoat />}
              price="499"
              discount="20% Off"
              discountedPrice="399"
              washType="PREMIUMHYBRIDCERMARICCOAT"
              vehicleType="BIKE"
              onBook={handleWashButtonClick}
              index={2}
            />
          </>
        )}

        {activeTab === "coat" && (
          <>
            {/* Water Repellent Treatment */}
            <WashCard
              title="Water Repellent Treatment"
              img={water_repellent_image}
              ulItems={[
                "Hydrophobic coating on glass",
                "Improves rain visibility",
              ]}
              dialogHeading="Water Repellent Treatment"
              dialogContent={<WaterRepellentCarGlass />}
              price="999"
              discount="10% Off"
              discountedPrice="899"
              washType="WATERREPELLENT"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={0}
            />

            {/* Rubbing + Wax Coating (Car) */}
            <WashCard
              title="Rubbing + Wax Coating"
              img={car_rubbing_coating_image}
              ulItems={["Paint restoration & gloss", "UV protection with wax"]}
              dialogHeading="Rubbing + Wax Coating"
              dialogContent={<RubbingAndWaxCoating />}
              price="3499"
              discount="43% Off"
              discountedPrice="1999"
              washType="RUBBINGCOATING"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={1}
            />

            {/* Rubbing (Car) */}
            <WashCard
              title="Rubbing Service"
              img={car_rubbing_image}
              ulItems={["Removes minor scratches", "Restores paint gloss"]}
              dialogHeading="Rubbing Service"
              dialogContent={<RubbingCarWash />}
              price="1999"
              discount="25% Off"
              discountedPrice="1499"
              washType="RUBBING"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={2}
            />

            {/* Bike Rubbing & Coating */}
            <WashCard
              title="Bike Rubbing & Coating"
              img={bike_rubbing_and_coating_image}
              ulItems={[
                "Removes minor scratches",
                "Restores gloss and color",
                "Glass & visor polishing",
              ]}
              dialogHeading="Bike Rubbing & Coating"
              dialogContent={<BikeRubbingAndCoating />}
              price="999"
              discount="40% Off"
              discountedPrice="599"
              washType="RUBBINGCOATING"
              vehicleType="BIKE"
              onBook={handleWashButtonClick}
              index={3}
            />
         
          </>
        )}

        {activeTab === "interior" && (
          <>
            {/* Basic Interior Cleaning */}
            <WashCard
              title="Basic Interior Cleaning"
              img={car_interior_basic_image}
              ulItems={["Interior Vacuum Cleaning", "Dashboard & Interior Polish", "Seat Cleaning"]}
              dialogHeading="Basic Interior Cleaning"
              dialogContent={<BasicInteriorCleaning />}
              price="299"
              discount="17% Off"
              discountedPrice="249"
              washType="BASICINTERIOR"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={0}
            />

            {/* Premium Interior */}
            <WashCard
              title="Premium Interior"
              img={car_interior_premium_image}
              ulItems={["Deep Interior Vacuum Cleaning", "Premium Dashboard & Interior Polish", "Seat Deep Cleaning"]}
              dialogHeading="Premium Interior"
              dialogContent={<PremiumInterior />}
              price="399"
              discount="25% Off"
              discountedPrice="299"
              washType="PREMIUMINTERIOR"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={1}
            />

            {/* Premium Plus Interior */}
            <WashCard
              title="Premium Plus Interior"
              img={car_interior_premium_plus_image}
              ulItems={["Ultra Deep Interior Vacuum", "Showroom Quality Polish", "Premium Seat Cleaning"]}
              dialogHeading="Premium Plus Interior"
              dialogContent={<PremiumPlusInterior />}
              price="499"
              discount="20% Off"
              discountedPrice="399"
              washType="PREMIUMPLUSINTERIOR"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={2}
            />

            {/* Luxury Interior */}
            <WashCard
              title="Luxury Interior"
              img={car_interior_luxury_image}
              ulItems={["Complete Interior Detailing", "Ultra Premium Polish", "Luxury Seat Treatment"]}
              dialogHeading="Luxury Interior"
              dialogContent={<LuxuryInterior />}
              price="799"
              discount="12% Off"
              discountedPrice="699"
              washType="LUXURYINTERIOR"
              vehicleType="CAR"
              onBook={handleWashButtonClick}
              index={3}
            />
          </>
        )}

        {activeTab === "ppf" && (
          <section className="overflow-hidden rounded-2xl bg-white/80 backdrop-blur-lg shadow-xl mt-4 mb-6 mx-4 border border-white/20 px-4 py-6 sm:px-8 sm:py-8">
            <h2 className="font-extrabold text-center text-3xl mb-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-600 bg-clip-text text-transparent">
              PPF
            </h2>
            <img
              src={ppf_ceramic_raigarh_image}
              alt="PPF and Ceramic Coating — Bluewasher Raigarh"
              className="w-full max-w-3xl mx-auto rounded-xl shadow-lg object-contain"
            />
          </section>
        )}
      </div>

        <AppDownloadBanner />

        {/* Floating Call Button */}
        <Tooltip title="Call us" arrow placement="left">
          <a
            href="tel:9685599971"
            aria-label="Call BlueWasher"
            className="fixed right-6 z-50 flex items-center justify-center rounded-full h-16 w-16 md:h-20 md:w-20 text-white bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-600 shadow-2xl hover:shadow-3xl hover:scale-110 transition-all duration-300 ring-4 ring-emerald-300/50 backdrop-blur-sm animate-pulse"
            style={{
              bottom: '15%',
              boxShadow: '0 10px 40px rgba(16, 185, 129, 0.4)',
            }}
          >
            <PhoneIcon sx={{ fontSize: 28 }} />
          </a>
        </Tooltip>
      </div>
    </div>
  );
};

// Reusable WashCard Component
const WashCard = ({
  title,
  img,
  dialogHeading,
  dialogContent,
  price,
  discount,
  discountedPrice,
  washType,
  vehicleType,
  onBook,
  index = 0,
  disabled = false,
  disabledNote = "",
}) => {
  return (
    <div 
      className="overflow-hidden rounded-2xl bg-white/80 backdrop-blur-lg shadow-xl hover:shadow-2xl transition-all duration-500 pt-6 mt-4 mb-6 mx-4 border border-white/20 transform hover:scale-[1.02]"
      style={{
        animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
      }}
    >
      <div className="flex flex-col items-center px-6 py-6 sm:p-8">
        {/* Image centered with modern styling */}
        <div
          className="w-full max-w-md mb-6 relative group overflow-hidden rounded-2xl"
          style={{ aspectRatio: "16 / 10" }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
          <img
            className="absolute inset-0 h-full w-full object-cover rounded-2xl shadow-lg transform group-hover:scale-105 transition-transform duration-500 z-20"
            src={img}
            alt={title}
          />
        </div>
        
        {/* Wash name below image with gradient text */}
        <h2 className="font-extrabold text-center text-3xl mb-6 bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent animate-gradient">
          {title}
        </h2>

        {/* Price information with modern design */}
        <div className="w-full max-w-md mb-6 text-center">
          <div className="inline-flex items-baseline gap-3 px-6 py-3 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl border border-indigo-100 shadow-sm">
            <span className="text-sm text-gray-500 line-through">₹{price}</span>
            <span className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              ₹{discountedPrice}
            </span>
            <span className="text-sm font-semibold text-green-600 bg-green-100 px-2 py-1 rounded-full">
              {discount}
            </span>
          </div>
        </div>

        {/* View More and Book Now buttons in same row with modern styling */}
        <div className="w-full max-w-md flex gap-3 mb-4">
          <DialogBox
            heading={dialogHeading}
            content={dialogContent}
            price={price}
            discount={discount}
            discountedPrice={discountedPrice}
            showPrice={false}
          />
          <Button
            className="flex-1 h-12 text-base font-semibold rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            variant="contained"
            startIcon={<EventIcon />}
            onClick={() => onBook(washType, vehicleType)}
            disabled={disabled}
            sx={{
              textTransform: 'none',
              boxShadow: '0 10px 25px -5px rgba(99, 102, 241, 0.4)',
              '&:hover': {
                boxShadow: '0 15px 35px -5px rgba(99, 102, 241, 0.6)',
              },
              '&:disabled': {
                background: 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)',
                color: '#fff',
              }
            }}
          >
            Book
          </Button>
        </div>
        {disabled && disabledNote && (
          <p className="text-sm text-gray-500 text-center mt-2 mb-2 italic">
            {disabledNote}
          </p>
        )}
      </div>
    </div>
  );
};

export default LandingPage1;
